import { chakra } from '@chakra-ui/react';
import { useCallback, useMemo, useState } from 'react';
import {
  projectInDOM,
  useCameraChangedEvent,
} from '../../../components/orderContractor/shapes/util';
import {
  CoordinateResult,
  Point2,
} from '../../../domain/geometry/geometric-types';

type CoordinateResultVisualizationProps = {
  result: CoordinateResult;
  viewer: Autodesk.Viewing.Viewer3D;
};
export const CoordinateResultVisualization = ({
  result,
  viewer,
}: CoordinateResultVisualizationProps) => {
  // Just use an empty object so we can notify the component when the camera changes
  const [cameraPosition, setCameraPosition] = useState({});

  const result2d = useMemo<Point2>(
    () => projectInDOM(result.point, viewer),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [cameraPosition, result, viewer]
  );

  useCameraChangedEvent(
    viewer,
    useCallback(() => {
      setCameraPosition({});
    }, [])
  );

  return (
    <chakra.svg position="absolute" top="0" left="0" width="100%" height="100%">
      <chakra.circle
        cx={result2d[0]}
        cy={result2d[1]}
        r="5"
        fill={'teal.400'}
      />
    </chakra.svg>
  );
};
